import {defineStore} from 'pinia';

/** State shape for the navigation origin store */
export interface DrawerStoreState {
  origins: Map<string, {path: string, originPageTitle: string}>;
}

/** Actions for creating and retrieving navigation origin IDs */
export interface DrawerStoreActions {
  createOriginId(path: string, originPageTitle: string): string;
}

export const useNavigationOriginStore =
  /** Tracks navigation origins so back-navigation can return to the correct page */
  defineStore<'navigation-origin-store', DrawerStoreState, any, DrawerStoreActions>('navigation-origin-store', {
  state: () => ({
    origins: new Map(),
  }),
  actions: {
    createOriginId(targetPath: string, originPageTitle: string): string {
      let originId: string|null = null;

      for (const [id, value] of this.origins.entries()) {
        if (value.path === targetPath && value.originPageTitle === originPageTitle) {
          originId = id;
        }
      }

      if (!originId) {
        originId = crypto.randomUUID();
        this.origins.set(originId, {path: targetPath, originPageTitle});
      }

      return originId;
    },
  },
});